import { useNavigate } from 'react-router';

import { useAPIContext } from '../../api/context';
import { Title } from '../../utils/title';
import Layout from './Layout';
import styles from './_02_Phone.module.scss';

const _02_Phone = () => {

  const { token } = useAPIContext();

  const navigate = useNavigate();

  const next = () => {
    navigate('/wizard/profile');
  };

  return (
    <>
      <Title value='Phone' />
      <Layout step='phone' auth={true}>
        <div className={styles.root}>
          <form onSubmit={e => { e.preventDefault(); next(); }}>

            <div>
              <label>We will ask you to verify your phone number when participating in a campaign.</label>
            </div>

            <button type='submit'>

              OK

            </button>

          </form>
        </div>
      </Layout>
    </>
  );
};

export default _02_Phone;
